import { Globals as M } from "@react-spring/core";
import { unstable_batchedUpdates as N } from "react-dom";
import { createStringInterpolator as U, colors as D } from "@react-spring/shared";
import { createHost as H } from "@react-spring/animated";
var k = /^--/;
function I(t, e) {
  return e == null || typeof e == "boolean" || e === "" ? "" : typeof e == "number" && e !== 0 && !k.test(t) && !(c.hasOwnProperty(t) && c[t]) ? e + "px" : ("" + e).trim();
}
var v = {};
function V(t, e) {
  if (!t.nodeType || !t.setAttribute) return !1;
  let r = t.nodeName === "filter" || t.parentNode && t.parentNode.nodeName === "filter",
    {
      style: i,
      children: s,
      scrollTop: u,
      scrollLeft: l,
      viewBox: a,
      ...n
    } = e,
    d = Object.values(n),
    m = Object.keys(n).map(o => r || t.hasAttribute(o) ? o : v[o] || (v[o] = o.replace(/([A-Z])/g, p => "-" + p.toLowerCase())));
  s !== void 0 && (t.textContent = s);
  for (let o in i) if (i.hasOwnProperty(o)) {
    let p = I(o, i[o]);
    k.test(o) ? t.style.setProperty(o, p) : t.style[o] = p;
  }
  m.forEach((o, p) => {
    t.setAttribute(o, d[p]);
  }), u !== void 0 && (t.scrollTop = u), l !== void 0 && (t.scrollLeft = l), a !== void 0 && t.setAttribute("viewBox", a);
}
var c = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
  F = (t, e) => t + e.charAt(0).toUpperCase() + e.substring(1),
  L = ["Webkit", "Ms", "Moz", "O"];
c = Object.keys(c).reduce((t, e) => (L.forEach(r => t[F(r, e)] = t[e]), t), c);
import { AnimatedObject as S } from "@react-spring/animated";
import { is as b, each as f, toArray as E, eachProp as P, FluidValue as T, getFluidValue as w, callFluidObservers as j, hasFluidValue as A, addFluidObserver as R, removeFluidObserver as W } from "@react-spring/shared";
var _ = /^(matrix|translate|scale|rotate|skew)/,
  $ = /^(translate)/,
  G = /^(rotate|skew)/,
  y = (t, e) => b.num(t) && t !== 0 ? t + e : t,
  h = (t, e) => b.arr(t) ? t.every(r => h(r, e)) : b.num(t) ? t === e : parseFloat(t) === e,
  g = class extends S {
    constructor(_ref) {
      let {
        x: e,
        y: r,
        z: i,
        ...s
      } = _ref;
      let u = [],
        l = [];
      (e || r || i) && (u.push([e || 0, r || 0, i || 0]), l.push(a => [`translate3d(${a.map(n => y(n, "px")).join(",")})`, h(a, 0)])), P(s, (a, n) => {
        if (n === "transform") u.push([a || ""]), l.push(d => [d, d === ""]);else if (_.test(n)) {
          if (delete s[n], b.und(a)) return;
          let d = $.test(n) ? "px" : G.test(n) ? "deg" : "";
          u.push(E(a)), l.push(n === "rotate3d" ? _ref2 => {
            let [m, o, p, O] = _ref2;
            return [`rotate3d(${m},${o},${p},${y(O, d)})`, h(O, 0)];
          } : m => [`${n}(${m.map(o => y(o, d)).join(",")})`, h(m, n.startsWith("scale") ? 1 : 0)]);
        }
      }), u.length && (s.transform = new x(u, l)), super(s);
    }
  },
  x = class extends T {
    constructor(r, i) {
      super();
      this.inputs = r;
      this.transforms = i;
    }
    _value = null;
    get() {
      return this._value || (this._value = this._get());
    }
    _get() {
      let r = "",
        i = !0;
      return f(this.inputs, (s, u) => {
        let l = w(s[0]),
          [a, n] = this.transforms[u](b.arr(l) ? l : s.map(w));
        r += " " + a, i = i && n;
      }), i ? "none" : r;
    }
    observerAdded(r) {
      r == 1 && f(this.inputs, i => f(i, s => A(s) && R(s, this)));
    }
    observerRemoved(r) {
      r == 0 && f(this.inputs, i => f(i, s => A(s) && W(s, this)));
    }
    eventObserved(r) {
      r.type == "change" && (this._value = null), j(this, r);
    }
  };
var C = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"];
export * from "@react-spring/core";
M.assign({
  batchedUpdates: N,
  createStringInterpolator: U,
  colors: D
});
var q = H(C, {
    applyAnimatedValues: V,
    createAnimatedStyle: t => new g(t),
    getComponentProps: _ref3 => {
      let {
        scrollTop: t,
        scrollLeft: e,
        ...r
      } = _ref3;
      return r;
    }
  }),
  it = q.animated;
export { it as a, it as animated };